<template>
  <label
    class="block overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium placeholder:text-neutral-0"
    :class="[disabled ? 'text-neutral-80' : 'text-neutral-40']"
  >
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "InputLabel",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
